(function () {
  function pad(num) {
    return String(num).padStart(2, '0');
  }

  function initCountdown(el) {
    if (el.getAttribute('data-countdown-initialized') === 'true') return;
    el.setAttribute('data-countdown-initialized', 'true');

    var endAttr = el.getAttribute('data-countdown-end');
    var endDate = new Date(endAttr);

    if (isNaN(endDate.getTime())) {
      // Date invalide renseignée dans les réglages : on masque plutôt que
      // d'afficher un compte à rebours cassé.
      var wrapper = el.closest('[data-countdown-wrapper]');
      if (wrapper) wrapper.style.display = 'none';
      return;
    }

    var daysEl = el.querySelector('[data-cd-days]');
    var hoursEl = el.querySelector('[data-cd-hours]');
    var minutesEl = el.querySelector('[data-cd-minutes]');
    var secondsEl = el.querySelector('[data-cd-seconds]');
    var timer = null;

    function update() {
      var now = new Date();
      var diff = endDate.getTime() - now.getTime();

      if (diff <= 0) {
        clearInterval(timer);
        var wrapper = el.closest('[data-countdown-wrapper]');
        if (wrapper) wrapper.style.display = 'none';
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    update();
    timer = setInterval(update, 1000);
  }

  function initAll() {
    var countdowns = document.querySelectorAll('[data-countdown]');
    countdowns.forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();